import React from "react";
import Box from "@material-ui/core/Box";
import VisitIcon from "view/images/VisitIcon";
import Typography from "@material-ui/core/Typography";
import {apiV2} from "api/firebase";
import useStyles from "./styles";

type SSOVisitProps = {
  showId: string;
  exhibitorPairId: string;
};

function SSOVisit({showId, exhibitorPairId}: SSOVisitProps) {
  const classes = useStyles({headerBackground: false});

  const handleButtonClick = async () => {
    const {link} = await apiV2.visit.getSsoLink({
      showId,
      exhibitorPairId,
    });

    if (!link) {
      return;
    }
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <div>
      <Box className={classes.tooltipAppItem}>
        <Box className={classes.tooltipItemLink} onClick={handleButtonClick}>
          <VisitIcon />
          <Typography>Visit</Typography>
        </Box>
      </Box>
    </div>
  );
}

export default SSOVisit;
